import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { stringify } from "query-string";
import withViewport from "../Viewport/withViewport";
import withTranslation from "../translation";
import styles from "./index.css";
import IconNotification from "../IconNotification";
import { getMyAccountBaseUrl } from "../../helpers/externalLinks";
import classnames from "classnames";
import { tabIndex } from "../../../helpers/accessibility";
import {
  CONTACT_PREFERENCES,
  MY_ACCOUNT_CRISTMAS_LOGGEDIN,
  MY_ACCOUNT_CRISTMAS_LOGGEDOUT,
  MY_ACCOUNT_EASTER_LOGGEDIN,
  MY_ACCOUNT_EASTER_LOGGEDOUT,
  MY_ACCOUNT_STPATRICKS_LOGGEDIN,
  MY_ACCOUNT_STPATRICKS_LOGGEDOUT,
  MY_ACCOUNT,
  MY_ORDERS,
  RETURNS_INFORMATION
} from "./constants";

const cx = classnames.bind(styles);

class MyAccountLinks extends PureComponent {
  static propTypes = {
    countryCode: PropTypes.string.isRequired,
    defaultStoreUrl: PropTypes.string.isRequired,
    eventIconToggle: PropTypes.oneOfType([
      PropTypes.shape({
        christmas: PropTypes.bool,
        easter: PropTypes.bool,
        stPatricks: PropTypes.bool
      }),
      PropTypes.bool
    ]),
    focusable: PropTypes.bool,
    formatTranslation: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    isReconsentRequired: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool,
    keyStoreDataversion: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    queryParams: PropTypes.object,
    storeCode: PropTypes.string.isRequired
  };

  buildLinks() {
    const {
      countryCode,
      defaultStoreUrl,
      formatTranslation,
      isReconsentRequired,
      keyStoreDataversion,
      lang,
      queryParams = {},
      storeCode
    } = this.props;

    const queryString =
      "?" +
      stringify({
        ...queryParams,
        lang,
        store: storeCode,
        country: countryCode,
        keyStoreDataversion
      });

    const baseUrl = getMyAccountBaseUrl();

    const links = [
      {
        id: MY_ACCOUNT,
        href: baseUrl + queryString,
        showNotification: false
      },
      {
        id: MY_ORDERS,
        href: `${baseUrl}/orders${queryString}`,
        showNotification: false
      },
      {
        id: RETURNS_INFORMATION,
        href: defaultStoreUrl.concat(
          formatTranslation(`MyAccountLinks.${RETURNS_INFORMATION}Link`),
          "&",
          stringify(queryParams)
        ),
        showNotification: false
      },
      {
        id: CONTACT_PREFERENCES,
        href: `${baseUrl}/contact-preferences${queryString}`,
        showNotification: isReconsentRequired
      }
    ];

    return links;
  }

  activeEvent(id) {
    const { eventIconToggle, isLoggedIn } = this.props;
    const { christmas, stPatricks, easter } = eventIconToggle;

    const eventIcons = [
      {
        event: christmas,
        loggedIn: MY_ACCOUNT_CRISTMAS_LOGGEDIN,
        loggedOut: MY_ACCOUNT_CRISTMAS_LOGGEDOUT
      },
      {
        event: stPatricks,
        loggedIn: MY_ACCOUNT_STPATRICKS_LOGGEDIN,
        loggedOut: MY_ACCOUNT_STPATRICKS_LOGGEDOUT
      },
      {
        event: easter,
        loggedIn: MY_ACCOUNT_EASTER_LOGGEDIN,
        loggedOut: MY_ACCOUNT_EASTER_LOGGEDOUT
      }
    ];

    const activeEvent = eventIcons.find(eventIcon => eventIcon.event);

    if (id !== MY_ACCOUNT || !activeEvent) {
      return false;
    }

    const icon = isLoggedIn ? activeEvent.loggedIn : activeEvent.loggedOut;

    return icon;
  }

  render() {
    const { focusable, formatTranslation, isVisible } = this.props;

    if (!isVisible) return null;

    return (
      <Fragment>
        {this.buildLinks().map(({ id, href, showNotification }) => (
          <a
            href={href}
            className={cx(
              styles.link,
              this.activeEvent(id) ? styles[this.activeEvent(id)] : styles[id]
            )}
            key={id}
            tabIndex={tabIndex(focusable)}
            data-testid={`${id.toLowerCase()}-link`}
          >
            {showNotification && (
              <span className={cx(styles.notificationContainer)}>
                <IconNotification />
              </span>
            )}
            {formatTranslation(`MyAccountLinks.${id}`)}
          </a>
        ))}
      </Fragment>
    );
  }
}

MyAccountLinks.defaultProps = {
  eventIconToggle: {
    christmas: false,
    easter: false,
    stPatricks: false
  }
};

export default withViewport(withTranslation(MyAccountLinks));
